import React from "react";
import Banner from "../components/utilities/Banner";
import ContactSocial from "../components/ConatactUs/ContactSocial";
function ContactUS() {
  return (
    <div className="container ">
      <Banner />
      <ContactSocial />
    </div>
  );
}

export default ContactUS;
